// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Dialog_dialog__320uk","header":"Dialog_header__IST6u","close":"Dialog_close__1Pa2S","content":"Dialog_content__3-R-j","back":"Dialog_back__VjcAZ"};